import { useState, useEffect, PointerEvent } from "react";
import I18n from "common/i18n";

// ピースプレビュー専用のスタートボタン（横長 pill のゲーム風立体ボタン）。
// 配色は .alpha .btn-primary（#2bdc98 / 影 #167752）の緑ファミリ。
// 下側 6px の厚みを持ち、押下で厚みごと沈む。disabled は btn-primary:disabled と
// 同じ思想のフラットなグレー面（彩度抜き等の加工はしない）。
// 親（MainScene）の absolute コンテナ内に置かれる前提で、自身は見た目のみ持つ。
export const PreviewStartBtn = ({
  scale,
  disabled,
  start,
}: {
  scale: number;
  disabled: boolean;
  start: () => void;
}) => {
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    setDisable(false);
  }, []);

  const handleStart = (e: PointerEvent) => {
    if (!disable && !disabled && e.isPrimary) {
      setDisable(true);
      start();
    }
  };

  return (
    <div
      data-guide="test_start"
      className="flex-col-el flex-center origin-bottom pointer-events-auto"
      style={{ transform: `scale(${scale})`, marginBottom: 24 * scale }}
    >
      <button
        type="button"
        disabled={disabled}
        onPointerDown={handleStart}
        aria-label={I18n.t("MSG_COURSE_GAME_START_BTN")}
        className="type-inherit-font flex-row-el items-center justify-center box-border gap-3 h-20 pl-6 pr-8 rounded-full border-none cursor-pointer select-none bg-gradient-to-b from-[#52eeb3] to-[#1bbd80] shadow-[0_6px_0_0_#149666,0_12px_20px_rgba(20,150,102,0.35)] transition-all duration-100 active:translate-y-[6px] active:shadow-[0_0_0_0_#149666,0_3px_8px_rgba(20,150,102,0.3)] disabled:bg-none disabled:bg-[#e0e4e7] disabled:shadow-none disabled:cursor-default"
      >
        <span className="flex-col-center w-12 h-12 rounded-full bg-white shadow-[inset_0_-2px_3px_rgba(0,0,0,0.08)]">
          <span className="material-symbols-outlined material-symbols-filled type-title text-[#1bbd80]">
            play_arrow
          </span>
        </span>
        <p className="type-text type-title text-white whitespace-nowrap drop-shadow-[0_2px_0_rgba(0,0,0,0.12)]">
          {I18n.t("MSG_COURSE_GAME_START_BTN")}
        </p>
      </button>
    </div>
  );
};
